import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getLikes, getUnLikes } from "./likeUnlikeApi";
export const initialState = {
  likes: 0,
  unlikes: 0,
  isPending: false,
  isError: false,
  error: "",
};

export const likeThunk = createAsyncThunk(
  "likeUnlike/like",
  async ({ id, likes }) => {
    const response = await getLikes({ id, likes });
    // The value we return becomes the `fulfilled` action payload
    console.log(response.likes);
    return response.likes;
  }
);
export const unlikeThunk = createAsyncThunk(
  "likeUnlike/unlike",
  async ({ id, unlikes }) => {
    const response = await getUnLikes({ id, unlikes });
    // The value we return becomes the `fulfilled` action payload
    console.log(response.likes);
    return response.unlikes;
  }
);
//
export const likeSlice = createSlice({
  name: "like",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  extraReducers: (builder) => {
    builder
      .addCase(likeThunk.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(likeThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // console.log(action.payload);
        state.isError = false;
        state.likes = action.payload;
      })
      .addCase(likeThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.likes = 0;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default likeSlice.reducer;
